import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="&#244;&#128;&#133;&#188;" d="M0 6C0 5.78017 0.078853 5.5914 0.236559 5.43369C0.394265 5.27121 0.583035 5.18996 0.802867 5.18996H5.19713V0.802867C5.19713 0.583035 5.27599 0.394265 5.43369 0.236559C5.5914 0.078853 5.78017 0 6 0C6.22461 0 6.41577 0.078853 6.57348 0.236559C6.73118 0.394265 6.81004 0.583035 6.81004 0.802867V5.18996H11.1971C11.417 5.18996 11.6057 5.27121 11.7634 5.43369C11.9211 5.5914 12 5.78017 12 6C12 6.22461 11.9211 6.41577 11.7634 6.57348C11.6057 6.7264 11.417 6.80287 11.1971 6.80287H6.81004V11.2043C6.81004 11.4194 6.73118 11.6057 6.57348 11.7634C6.41577 11.9211 6.22461 12 6 12C5.78017 12 5.5914 11.9211 5.43369 11.7634C5.27599 11.6057 5.19713 11.4194 5.19713 11.2043V6.80287H0.802867C0.583035 6.80287 0.394265 6.7264 0.236559 6.57348C0.078853 6.41577 0 6.22461 0 6Z" />
</svg>

`;

export const Plus = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
